<template lang="pug">
vm-row(class="card-custom")
  vm-col(v-if="type == 'text'" class="card-custom__money" vm-type="flex" vm-align="center")
    .card-custom__money__text
      span() {{ title }}
      p(:class="color") {{textValue | currency}} {{currency}}
  vm-col(v-if="type == 'title'" class="card-custom__money" vm-type="flex" vm-align="center")
    .card-custom__money__text
      span() {{ title }}
      p(:class="color") {{ textValue }}
  vm-col(v-if="type == 'title-large'" class="card-custom__large" vm-type="flex" vm-align="center")
    .card-custom__large__text
      span() {{ title }}
    .card-custom__large__text
      p {{ textValue | currency}}
</template>
<script>
export default {
  name: 'MoneyCard',
  props: {
    color: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    textValue: {
      type: String,
      default: null
    },
    currency: {
      default: () => ('USD'),
      type: String
    },
    type: {
      type: String,
      default: 'text'
    }
  }
}
</script>
<style lang="scss" scoped>
.card-custom {
  &__money {
    padding-left: 25px;
    display: flex;
    flex-direction: row;
    span {
    color: #9EA5AB;
    font-size: 18px;
    font-weight: 600;
    line-height: 21px;
    margin-bottom: 10px;
    }
    p {
      font-weight: 400;
      font-size: 30px;
      line-height: 30px;
    }
  }
  &__large {
    padding-left: 25px;
    display: flex;
    justify-content: space-between;
    span {
    font-size: 24px;
    font-weight: 600;
    line-height: 21px;
    margin-bottom: 10px;
    }
    p {
      font-weight: 400;
      font-size: 30px;
      line-height: 30px;
    }
  }
}
.green {
  color: #1EC772;
}
.primary {
  color: rgba(var(--primary), 1);
}
</style>
